import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { MINIMUM_AGE_OVERRIDES_FLAG, setMinimumAgeOverridesFlag } from 'state/minimum-age-overrides-flag';

export default function useMinimumAgeOverridesFlagController(): void {
  const flags = useFlags();
  const rawMinimumAgeOverridesFlagValue = flags[MINIMUM_AGE_OVERRIDES_FLAG];

  useEffect(() => {
    setMinimumAgeOverridesFlag(rawMinimumAgeOverridesFlagValue);
  }, [rawMinimumAgeOverridesFlagValue]);
}
